module.exports = "/images/aerial-20.jpg";